import {
  legacy_createStore,
  compose,
  applyMiddleware,
  combineReducers,
  Reducer,
  UnknownAction,
  Action,
} from 'redux';
import { thunk, ThunkDispatch } from 'redux-thunk';
import { AuthState, reducer as auth } from '@src/store/auth.js';
import { ConfigState, reducer as config } from '@src/store/config.js';
import { ConsentsState, reducer as consents } from '@src/store/consents.js';
import { eventsMiddleware } from '@src/store/middleware/events.js';
import { persist, loadState } from '@src/store/middleware/persist.js';
import { scroller } from '@src/store/middleware/scroller.js';
import { tracker } from '@src/store/middleware/tracker.js';

export const RESET = 'RESET';

export type RootState = {
  auth: AuthState;
  config: ConfigState;
  consents: ConsentsState;
  globalOfferId: string;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const appReducer: Reducer<RootState> = combineReducers({
  config,
  auth,
  consents,
});

const rootReducer = (
  state: RootState,
  action: UnknownAction,
) => {
  const startState = action.type === RESET ? loadState() : state;
  return appReducer(startState, action);
};

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = legacy_createStore<RootState, UnknownAction, {
  dispatch: ThunkDispatch<RootState, void, Action>
  // @ts-expect-error quick and dirty ts fix
}, unknown>(
  rootReducer,
  undefined,
  composeEnhancers(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    applyMiddleware(thunk, persist, eventsMiddleware, tracker, scroller),
  ),
);

export type AppDispatch = typeof store.dispatch;
